import React from 'react';
import Youtube from 'react-lazyload-youtube';
import { ImgBox } from 'views/common/components';
import StyledBox from 'views/rebranded-module/common/components/UI/IsVideoOrImg/IsVideoOrImg.styles';

const IsVideoOrImg = (props) => {
  const { slide } = props;
  if (!slide) return null;

  if (slide.youtube_id) {
    return (
      <StyledBox
        className="IVOIvideo"
        component="span"
        height="100%"
        width="100%">
        <Youtube
          videoId={slide.youtube_id}
          height="100%"
          width="100%"
          imgSize="hqdefault"
        />
      </StyledBox>
    );
  }

  return (
    <ImgBox
      image={{
        src: slide.image.large_url,
        alt: 'Gallery media item',
      }}
      imgWidth="100%"
      imgHeight="100%"
      objectFit="cover"
      unoptimized
      objectPosition="50% 50%"
    />
  );
};

export { IsVideoOrImg };
